/**
 * <dtf-hotspots> — Shop the Look のホットスポット。ドット押下でミニ商品カードを開閉。
 * 1つずつ開く / 外側クリック・Esc で閉じる。
 */
class DtfHotspots extends HTMLElement {
  connectedCallback() {
    if (this._initialized) return;

    this._initialized = true;
    this.spots = Array.from(this.querySelectorAll('[data-hotspot]'));
    // ドットの親（.dtf-stl__spot）は z-index を持つ＝独立した重なり文脈。
    // 開いたポップアップが後続のドットに隠れないよう、親側にも is-open を付けて前面に出す。
    this.wrappers = this.spots.map((button) => button.parentElement);
    this.pops = this.spots.map((button) => button.parentElement?.querySelector('[data-pop]'));
    this._openIndex = -1;

    this._onClick = (event) => {
      if (!(event.target instanceof Element)) return;

      const button = event.target.closest('[data-hotspot]');
      if (!button || !this.contains(button)) return;

      event.stopPropagation();
      const index = this.spots.indexOf(button);
      if (index >= 0) this.toggle(index);
    };

    this._onDoc = (event) => {
      if (!(event.target instanceof Element)) return;
      if (!event.target.closest('[data-pop]') && !event.target.closest('[data-hotspot]')) this.close(false);
    };
    this._onKey = (event) => {
      if (event.key !== 'Escape' || this._openIndex < 0) return;

      event.preventDefault();
      this.close(true);
    };
    this.addEventListener('click', this._onClick);
    document.addEventListener('click', this._onDoc);
    document.addEventListener('keydown', this._onKey);
  }

  disconnectedCallback() {
    this.close(false);
    this.removeEventListener('click', this._onClick);
    document.removeEventListener('click', this._onDoc);
    document.removeEventListener('keydown', this._onKey);
    this._initialized = false;
  }

  toggle(index) {
    if (this._openIndex === index) {
      this.close(false);
      return;
    }

    this.close(false);
    this._openIndex = index;
    this.pops[index]?.classList.add('is-open');
    this.pops[index]?.setAttribute('aria-hidden', 'false');
    this.spots[index]?.setAttribute('aria-expanded', 'true');
    this.spots[index]?.classList.add('is-active');
    this.wrappers[index]?.classList.add('is-open');
  }

  close(restoreFocus = false) {
    if (this._openIndex < 0) return;

    const button = this.spots[this._openIndex];
    this.pops[this._openIndex]?.classList.remove('is-open');
    this.pops[this._openIndex]?.setAttribute('aria-hidden', 'true');
    button?.setAttribute('aria-expanded', 'false');
    button?.classList.remove('is-active');
    this.wrappers[this._openIndex]?.classList.remove('is-open');
    this._openIndex = -1;
    if (restoreFocus) button?.focus();
  }
}

if (!customElements.get('dtf-hotspots')) {
  customElements.define('dtf-hotspots', DtfHotspots);
}
